export default __webpack_public_path__ + "static/media/nflStaff2.5ece38ee.jpg";